import { Loading3QuartersOutlined } from '@ant-design/icons';
import { Spin, Typography } from 'antd';
import React from 'react';

interface IProps {
  title?: string;
}

const SpinnerLoader = ({ title }: IProps) => {
  const antIcon = <Loading3QuartersOutlined className="loading3QuartersOutlinedStyled" spin={true} />;

  return (
    <div className="spinDiv">
      <div className="spinStyled">
        <Spin indicator={antIcon} className="m-b-5" />
        <br />
        <Typography.Text className="m-b-0 color-white">{title || 'Tải dữ liệu...'}</Typography.Text>
      </div>
    </div>
  );
};

export default React.memo(SpinnerLoader);
